<template>
  <div class="main-content">
    <!--
    <br>
    <select name="lieu" id="lieu" v-model="lieu" v-if="hideSelectDispo">
      <option value="">
        Veuillez choisir le lieu de votre disponibilité
      </option>
      <template v-for="l in lieuxDispo" :key="l.id">
        <option :value="l.id" :title="l.fulladresse">{{ l.nom }}</option>
      </template>
    </select>
    -->
    <br />
    <Toast />
    <div class="calendar-div">
      <FullCalendar ref="fullCalendar" :options="calendarOptions" />
    </div>

    <Dialog
      v-model:visible="showDispoMod"
      modal
      header="Ajouter une disponibilité"
      :style="{ width: '50vw' }"
      :breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
    >
      <select name="lieu" id="lieu" v-model="lieu">
        <option value="">
          Veuillez choisir le lieu de votre disponibilité
        </option>
        <template v-for="l in lieuxDispo" :key="l.id">
          <option :value="l.id" :title="l.fulladresse">{{ l.nom }}</option>
        </template>
      </select>
      <br />
      <br />
      <template v-if="loadDispoBtn == false">
        <button @click="setDispo()" class="btn btn-primary">VALIDER</button>
      </template>
      <template v-else>
        <button @click="setDispo()" class="btn btn-primary" disabled>
          <span><i class="fa fa-spinner fa-spin"></i>VALIDER</span>
        </button>
      </template>
    </Dialog>

    <Dialog
      v-model:visible="showResaMod"
      modal
      @update:visible="handleCloseResa"
      :header="headerResa"
      :style="{ width: '50vw' }"
      :breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
    >
      <template v-if="eleve.choixDispo == 'null'">
        <h4>
          Veuillez choisir vos moniteurs et lieux de rendez-vous pour réserver
          une heure de conduite
        </h4>
      </template>

      <template v-else>
        <div class="stepper">
          <div class="firstStep active" id="stepOne">1. Choix du Mono</div>
          <div class="link">----------------></div>
          <div class="secondStep inactive" id="stepTwo">2. Lieu de début</div>
          <div class="link">----------------></div>
          <div class="thirdStep inactive" id="stepThree">3. Lieu de fin</div>
        </div>

        <div class="moniteur" v-if="step == 1">
          <h3>Choix du moniteur</h3>
          <div class="inputMono">
            <template v-for="m in moniteurs" :key="m.id">
              <template v-if="m.choixEleve == true">
                <label class="container">
                  <input
                    type="radio"
                    name="moniteur"
                    :value="m.idMono"
                    v-model="monoResa"
                  />
                  <span class="checkmark"></span>
                  {{ m.fullname }}
                </label>
              </template>
            </template>
          </div>
        </div>

        <div class="lieuDeb" v-if="step == 2">
          <h3>Début du cours</h3>
          <template v-if="monoResa == ''"
            ><p>Veuillez choisir le moniteur</p></template
          >
          <template v-else>
            <div class="inputMono">
              <template v-for="l in lieuxDeb" :key="l.id">
                <template v-if="l.choixEleve == true">
                  <label class="container"
                    >{{ l.nom }}
                    <input
                      type="radio"
                      name="lieudeb"
                      :value="l.id"
                      v-model="lieuDeb"
                    />
                    <span class="checkmark"></span>
                  </label>
                </template>
              </template>
            </div>
          </template>
        </div>
        <br />
        <div class="lieuFin" v-if="step == 3">
          <h3>Fin du cours</h3>
          <template v-if="monoResa == ''"
            ><p>Veuillez choisir le moniteur</p></template
          >
          <template v-else-if="lieuxDeb.length == 0"
            >Veuillez choisir le lieu de début du cours</template
          >
          <template v-else>
            <div class="inputMono">
              <template v-for="l in gpLieuxFin" :key="l">
                <template v-if="l == 1">
                  <label class="container"
                    >{{
                      this.$store.state.elevePlanningInfo.agence.nom
                    }}
                    Impérativement
                    <input
                      type="radio"
                      name="lieufin"
                      :value="998"
                      v-model="LieuFin"
                    />
                    <span class="checkmark"></span>
                  </label>
                </template>
                <template v-else-if="l == 2">
                  <template v-for="lf in lieuxFin" :key="lf.id">
                    <template v-if="l == lf.groupe">
                      <label class="container"
                        >{{ lf.nom }} Impérativement - Le cours se termineras
                        {{ lf.time }} min avant
                        <input
                          type="radio"
                          name="lieufin"
                          :value="lf.id"
                          v-model="LieuFin"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </template>
                  </template>
                </template>
                <template v-else-if="l >= 3">
                  <template v-if="l != 100">
                    <template v-for="l in lieuxDeb" :key="l.id">
                      <template v-if="l.id == lieuDeb">
                        <label class="container">
                          {{
                            this.$store.state.elevePlanningInfo.agence.nom
                          }}
                          ou {{ l.nom }} selon les besoins de l'agence
                          <input
                            type="radio"
                            name="lieufin"
                            :value="1000"
                            v-model="LieuFin"
                          />
                          <span class="checkmark"></span>
                        </label>
                      </template>
                    </template>
                  </template>
                </template>
              </template>
            </div>
          </template>
        </div>

        <br />
        <br />
        <button
          @click="goBackInStep()"
          class="btn btn-primary"
          v-if="step != 1"
        >
          RETOUR
        </button>
        <button
          @click="choixMonoResa()"
          class="btn btn-primary stepBtn"
          v-if="step == 1"
        >
          ETAPE SUIVANTE
        </button>
        <button
          @click="getLieuFin()"
          class="btn btn-primary stepBtn"
          v-if="step == 2"
        >
          ETAPE SUIVANTE
        </button>
        <template v-if="loadResaBtn === false">
          <button
            @click="setResa()"
            class="btn btn-primary stepBtn"
            v-if="step == 3"
          >
            VALIDER
          </button>
        </template>
        <template v-else>
          <button
            @click="setResa()"
            class="btn btn-primary stepBtn"
            v-if="step == 3"
            disabled
          >
            <span><i class="fa fa-spinner fa-spin"></i>VALIDER</span>
          </button>
        </template>
      </template>
    </Dialog>

    <Dialog
      v-model:visible="popupMotif"
      modal
      header="Annulation du cours"
      :style="{ width: '440px', maxWidth: '95vw' }"
    >
      <div class="cancel-dialog">
        <div v-if="hAnnulation < limitAnnulation && limitGoBack > 30" class="cancel-badge cancel-badge--warning">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
          Attention
        </div>
        <div v-else class="cancel-badge cancel-badge--info">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
          Information
        </div>

        <p v-if="hAnnulation < limitAnnulation && limitGoBack > 30" class="cancel-message">
          Votre cours commence dans moins de <strong>{{ limitAnnulation }}h</strong>. Si vous l'annulez, il sera <strong>compté</strong>.
        </p>
        <p v-else class="cancel-message">
          Si vous annulez ce cours, il <strong>ne sera pas compté</strong>.
        </p>

        <div class="cancel-actions">
          <button class="cancel-btn cancel-btn--ghost" @click="popupMotif = false">Retour</button>
          <template v-if="!loadMotifBtn">
            <button class="cancel-btn cancel-btn--danger" @click="setMotif">Confirmer l'annulation</button>
          </template>
          <template v-else>
            <button class="cancel-btn cancel-btn--danger" disabled>
              <i class="fa fa-spinner fa-spin"></i> Confirmer l'annulation
            </button>
          </template>
        </div>
      </div>
    </Dialog>

    <Dialog
      v-model:visible="cancelRdvSimu"
      modal
      header="Cours sur simulateur"
      :style="{ width: '440px', maxWidth: '95vw' }"
    >
      <div class="cancel-dialog">
        <div class="cancel-badge cancel-badge--blocked">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/></svg>
          Non annulable
        </div>
        <p class="cancel-message">
          Les cours sur simulateur ne peuvent pas être annulés en ligne.<br>
          Veuillez contacter l'agence directement.
        </p>
        <div class="cancel-contact">
          <span>📞 {{ this.eleve.agence.tel }}</span>
          <span>✉️ {{ this.eleve.agence.mail }}</span>
        </div>
        <div class="cancel-actions">
          <button class="cancel-btn cancel-btn--ghost" @click="cancelRdvSimu = false">Fermer</button>
        </div>
      </div>
    </Dialog>

    <Dialog
      v-model:visible="showSimuDoneDialog"
      modal
      header="Simulateur terminé"
      :style="{ width: '420px', maxWidth: '95vw' }"
    >
      <div class="cancel-dialog">
        <div class="cancel-badge cancel-badge--free">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
          Simulateur terminé
        </div>
        <p class="cancel-message">
          Vous avez réservé vos heures sur simulateur.<br>
          Vous pouvez maintenant <strong>ajouter des moniteurs</strong> pour réserver des cours en véhicule.
        </p>
        <div class="cancel-actions">
          <button class="cancel-btn cancel-btn--ghost" @click="showSimuDoneDialog = false">Fermer</button>
        </div>
      </div>
    </Dialog>

    <Dialog
      v-model:visible="popupFreeCancel"
      modal
      header="Annulation gratuite"
      :style="{ width: '440px', maxWidth: '95vw' }"
    >
      <div class="cancel-dialog">
        <div class="cancel-badge cancel-badge--free">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
          Annulation gratuite
        </div>
        <p class="cancel-message">
          Vous avez réservé ce cours il y a moins de <strong>30 minutes</strong>. L'annulation est <strong>gratuite</strong>, ce cours ne sera pas compté.
        </p>
        <div class="cancel-actions">
          <button class="cancel-btn cancel-btn--ghost" @click="popupFreeCancel = false">Retour</button>
          <template v-if="!loadMotifBtn">
            <button class="cancel-btn cancel-btn--success" @click="setFreeCancel">Confirmer l'annulation</button>
          </template>
          <template v-else>
            <button class="cancel-btn cancel-btn--success" disabled>
              <i class="fa fa-spinner fa-spin"></i> Confirmer l'annulation
            </button>
          </template>
        </div>
      </div>
    </Dialog>

    <Dialog
      v-model:visible="showSoldeInsuffisantDialog"
      modal
      header="Solde insuffisant"
      :style="{ width: '400px', maxWidth: '95vw' }"
    >
      <div class="cancel-dialog">
        <div class="cancel-badge cancel-badge--blocked">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
          Solde insuffisant
        </div>
        <p class="cancel-message">
          Le solde de l'élève sélectionné est insuffisant.
        </p>
        <div class="cancel-actions">
          <button class="cancel-btn cancel-btn--info" @click="showSoldeInsuffisantDialog = false">Fermer</button>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import "@fullcalendar/core/vdom";
import FullCalendar from "@fullcalendar/vue3";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { useToast } from "primevue/usetoast";
import moment from "moment";

export default {
  props: ["eleve", "getEleveInfo", "clearValuesResa"],

  components: {
    FullCalendar,
  },

  data() {
    return {
      toast: useToast(),
      cancelRdvSimu: false,
      showSimuDoneDialog: false,
      simuHoursRemaining: 0,
      popupFreeCancel: false,
      showSoldeInsuffisantDialog: false,
      loadResaBtn: false,
      loadMotifBtn: false,
      loadDispoBtn: false,
      headerResa: "",
      step: 1,
      gpLieuxFin: [],
      motif: {
        leTypeMotif: null,
        com: "",
      },
      typeMotif: [],
      popupMotif: false,
      firstCours: false,
      boiteResa: "",
      lieuxDeb: [],
      lieuDeb: "",
      lieuxFin: [],
      LieuFin: "",
      monoResa: "",
      moniteurs: [],
      lieuxDispo: [],
      showDispoMod: false,
      showResaMod: false,
      lieu: "",
      selectEvent: "",
      mobileDispoStart: null,
      mobileDispoGhostId: null,
      lastDateClick: null,
      calendarOptions: {
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        initialView: "timeGridWeek",
        nowIndicator: true,
        eventResizableFromStart: false,
        firstDay: 1,
        allDaySlot: false,
        slotMinTime: "07:00:00",
        slotMaxTime: "21:00:00",
        slotDuration: "1:00:00",
        height: "80vh",
        expandRows: true,
        locale: "fr",
        selectable: true,
        timeZone: "local",
        eventClick: this.deleteEvent,
        eventDidMount: this.eventhover,
        customButtons: {
          hideSunday: {
            text: "Dimanche",
            click: (e) => this.hideSundayMethod(e),
            background: "red",
          },
          prev: {
            // this overrides the prev button
            text: "PREV",
            click: () => {
              //this.$store.commit("setDispoResaBtn", false);
              this.todayBtnActive = false;
              let calendarApi = this.$refs.fullCalendar.getApi();
              calendarApi.prev();
              let date = moment(calendarApi.getDate().toString()).format(
                "YYYY-MM-DDTHH:mm:ss",
              );

              if (this.dayWeekPlanning == false) {
                this.getEleveInfoChange(date, false);
              } else {
                this.getEleveInfoChange(date, true);
              }

              let resultDispo = this.calendarOptions.events.filter(
                (e) => e.type != "dispo",
              );
              this.calendarOptions.events = resultDispo;
            },
          },
          next: {
            // this overrides the next button, essayer de récupérer la semaine afficher suite auc lique du bouton next
            text: "NEXT",
            click: () => {
              this.todayBtnActive = false;
              this.nextBtnPress = true;
              let calendarApi = this.$refs.fullCalendar.getApi();
              calendarApi.next();
              let date = moment(calendarApi.getDate().toString()).format(
                "YYYY-MM-DDTHH:mm:ss",
              );

              if (this.dayWeekPlanning == false) {
                this.getEleveInfoChange(date, false);
              } else {
                this.getEleveInfoChange(date, true);
              }

              let resultDispo = this.calendarOptions.events.filter(
                (e) => e.type != "dispo",
              );
              this.calendarOptions.events = resultDispo;
            },
          },

          today: {
            // test
            text: "Aujourd'hui",
            click: () => {
              //this.$store.commit("setDispoResaBtn", false);
              this.todayBtnActive = false;
              this.nextBtnPress = false;
              let calendarApi = this.$refs.fullCalendar.getApi();
              if (this.calendarOptions.events != null) {
                this.calendarOptions.events = [];
                let today = new Date();
                let diff =
                  today.getDate() -
                  today.getDay() +
                  (today.getDay() === 0 ? -6 : 1);
                let monday = new Date(today.setDate(diff));
                let date = moment(monday).format("YYYY-MM-DDTHH:mm:ss");
                if (this.dayWeekPlanning == false) {
                  this.getEleveInfoChange(
                    moment(new Date()).format("YYYY-MM-DDT00:00:00"),
                    false,
                  );
                } else {
                  this.getEleveInfoChange(date, true);
                }
              }

              calendarApi.today();
            },
          },

          timeGridDay: {
            // this overrides the next button
            text: "Jour",
            click: () => {
              //this.$store.commit("setDispoResaBtn", false);
              let calendarApi = this.$refs.fullCalendar.getApi();
              calendarApi.changeView("timeGridDay");
              calendarApi.today();
              this.dayWeekPlanning = false;
              this.todayBtnActive = true;
              this.nextBtnPress = false;
              //this.$emit("getMoniteursChange", moment(new Date()).format("YYYY-MM-DDT00:00:00"), false);
              if (this.calendarOptions.events != null) {
                this.calendarOptions.events = [];
                let today = new Date();
                let diff =
                  today.getDate() -
                  today.getDay() +
                  (today.getDay() === 0 ? -6 : 1);
                let monday = new Date(today.setDate(diff));
                let date = moment(monday).format("YYYY-MM-DDTHH:mm:ss");
                if (this.dayWeekPlanning == false) {
                  this.getEleveInfoChange(
                    moment(new Date()).format("YYYY-MM-DDT00:00:00"),
                    false,
                  );
                } else {
                  this.getEleveInfoChange(date, true);
                }
              }
            },
          },

          timeGridWeek: {
            // this overrides the next button
            text: "Semaine",
            click: () => {
              this.$store.commit("setDispoResaBtn", false);
              let calendarApi = this.$refs.fullCalendar.getApi();
              calendarApi.changeView("timeGridWeek");
              calendarApi.today();
              this.dayWeekPlanning = true;
              this.todayBtnActive = true;
              this.nextBtnPress = false;
              if (this.calendarOptions.events != null) {
                this.calendarOptions.events = [];
                let today = new Date();
                let diff =
                  today.getDate() -
                  today.getDay() +
                  (today.getDay() === 0 ? -6 : 1);
                let monday = new Date(today.setDate(diff));
                let date = moment(monday).format("YYYY-MM-DDTHH:mm:ss");
                if (this.dayWeekPlanning == false) {
                  this.getEleveInfoChange(
                    moment(new Date()).format("YYYY-MM-DDT00:00:00"),
                    false,
                  );
                } else {
                  this.getEleveInfoChange(date, true);
                }
              }
            },
          },
        },
        headerToolbar: {
          start: "prev,next today",
          center: "title",
          end: "timeGridWeek,timeGridDay",
        },
        events: [],
        select: this.select,
        dateClick: this.handleDateClick,
        editable: false,
        selectAllow: this.selectAllow,
        eventChange: this.putDispoEleve,
      },
      dayWeekPlanning: true,
      todayBtnActive: true,
      nextBtnPress: false,
      hideSelectDispo: true,
      hAnnulation: 0,
      limitAnnulation: 48,
      limitGoBack: 0,
      apMono: null,
    };
  },

  mounted() {
    //this.getFonctionnalite();

    //this.calendarOptions.slotDuration = this.eleve.agence.dureeHeure + ":00:00";

    this.getLieuxEleve();
    this.getMoniteurs();
    this.putOnPlanningEleve();
    if (this.eleve.nbHeureSimu !== 'not' && this.eleve.nbHeureSimu > 0) {
      this.simuHoursRemaining = this.eleve.nbHeureSimu;
    }
  },

  watch: {
    showSimuDoneDialog(newVal, oldVal) {
      if (oldVal === true && newVal === false) {
        setTimeout(() => window.location.reload(), 0);
      }
    },
  },

  computed: {
    isMobile() {
      return window.innerWidth <= 768;
    },
  },

  methods: {
    reloadPage() {
      window.location.reload();
    },

    getMondayOfCurrentWeek() {
      const calendarApi = this.$refs.fullCalendar.getApi();
      const currentDate = calendarApi.getDate();

      const day = currentDate.getDay();
      const diff = day === 0 ? -6 : 1 - day;

      let monday = new Date(currentDate);
      monday.setDate(monday.getDate() + diff);
      // Construire une date propre sans se soucier du fuseau
      return new Date(
        monday.getFullYear(),
        monday.getMonth(),
        monday.getDate(),
        0,
        0,
        0,
      );
    },

    getHeuresResaWeek() {
      let nowDate = new Date();
      const lundi = this.getMondayOfCurrentWeek();
      window.api
        .post(
          "/horaire/planning/eleve/semaine",
          {
            dateDebut: lundi,
            monoId: this.monoResa,
            eleveId: this.$store.state.user.id,
            now: moment(nowDate.date).format("YYYY-MM-DDTHH:mm:ss"),
          },
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          },
        )
        .then((response) => {
          this.calendarOptions.events = this.calendarOptions.events.filter(
            (e) => e.type != "creneaudispo",
          );
          this.calendarOptions.events = this.calendarOptions.events.filter(
            (e) => e.type != "creneauindispo",
          );
          this.calendarOptions.events = this.calendarOptions.events.filter(
            (e) => e.type != "indispoEleve",
          );
          let i = 1000000;
          response.data.heures.forEach((c) => {
            if (c.disponible) {
              this.calendarOptions.events.push({
                id: i,
                title: "CRENEAU DISPO",
                start: moment(c.fullDate.start).format("YYYY-MM-DDTHH:mm:ss"),
                end: moment(c.fullDate.end).format("YYYY-MM-DDTHH:mm:ss"),
                color: "#bf616a",
                type: "creneaudispo",
              });
            } else {
              this.calendarOptions.events.push({
                id: i,
                title: "INDISPO",
                start: moment(c.fullDate.start).format("YYYY-MM-DDTHH:mm:ss"),
                end: moment(c.fullDate.end).format("YYYY-MM-DDTHH:mm:ss"),
                color: "grey",
                type: "creneauindispo",
              });
            }
            i++;
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    setupMonoChoice(mono) {
      this.apMono = mono;
      this.monoResa = mono.idMono;
      this.getHeuresResaWeek();
      let calendarApi = this.$refs.fullCalendar.getApi();
      const view = calendarApi.view;

      const startplan = view.currentStart;
      const endplan = view.currentEnd;

      let events = this.calendarOptions.events.filter((e) => e.type != "boite");
      this.calendarOptions.events = events;

      if (mono != "null") {
        if (mono.params.length > 0) {
          let dateNow = new Date();
          mono.params.forEach((i) => {
            let today = new Date();
            let todayDay = today.getDay();
            let startDate = new Date(i.start);
            let endDate = new Date(i.end);
            let startDay = startDate.getDay();
            let endDay = endDate.getDay();
            let diffStart =
              today.getDate() - todayDay + (todayDay == 0 ? -6 : startDay); // permet de récupérer un jour précis de la semaine actuel en mettant l'id du jour (0 = dimanche 1 = lundi...)
            let diffEnd =
              today.getDate() - todayDay + (todayDay == 0 ? -6 : endDay); // permet de récupérer un jour précis de la semaine actuel en mettant l'id du jour (0 = dimanche 1 = lundi...)

            startDate = new Date(today.setDate(diffStart));
            endDate = new Date(today.setDate(diffEnd));

            if (startDay == 0) {
              startDate = startDate.setDate(startDate.getDate() + 1 * 7);
              startDate = new Date(startDate);
            }

            if (endDay == 0) {
              endDate = endDate.setDate(endDate.getDate() + 1 * 7);
              endDate = new Date(endDate);
            }

            let ddStart = String(startDate.getDate()).padStart(2, "0");
            let ddEnd = String(endDate.getDate()).padStart(2, "0");
            let mm = String(today.getMonth() + 1).padStart(2, "0");
            let yyyy = today.getFullYear();

            let start =
              yyyy + "-" + mm + "-" + ddStart + "T" + i.start.split("T")[1];
            let end = yyyy + "-" + mm + "-" + ddEnd + "T" + i.end.split("T")[1];

            if (i.title == "INDISPO") {
              this.calendarOptions.events.push({
                id: i.id,
                title: "INDISPO",
                start: moment(start).format("YYYY-MM-DDTHH:mm:ss"),
                end: moment(end).format("YYYY-MM-DDTHH:mm:ss"),
                color: "grey",
                type: "boite",
                display: "background",
              });
            }
          });
          // CODE QUI PERMET D'AFFICHER LES INDISPOS BOITE QUAND ON PREV OU NEXT SUR LE PLANNING
          if (dateNow > endplan) {
            const diffMs = Math.abs(dateNow - endplan); // différence en millisecondes
            const diffJours = diffMs / (1000 * 60 * 60 * 24); // en jours
            let diffSemaines = Math.floor(diffJours / 7);
            diffSemaines = diffSemaines + 1;

            if (this.dayWeekPlanning == false) {
              if (this.calendarOptions.events != null) {
                this.calendarOptions.events.forEach((e) => {
                  if (e.type == "boite") {
                    if (calendarApi.getDate().getDay() == 0) {
                      let start = moment(e.start).subtract(
                        diffSemaines,
                        "week",
                      );
                      let end = moment(e.end).subtract(diffSemaines, "week");
                      e.start = start.format("YYYY-MM-DDTHH:mm:ss");
                      e.end = end.format("YYYY-MM-DDTHH:mm:ss");
                    } else {
                      if (this.nextBtnPress) {
                        let start = moment(e.start).subtract(
                          diffSemaines,
                          "week",
                        );
                        let end = moment(e.end).subtract(diffSemaines, "week");
                        e.start = start.format("YYYY-MM-DDTHH:mm:ss");
                        e.end = end.format("YYYY-MM-DDTHH:mm:ss");
                        this.nextBtnPress = false;
                      }
                    }
                  }
                });
              }
            } else {
              if (this.calendarOptions.events != null) {
                this.calendarOptions.events.forEach((e) => {
                  if (e.type == "boite") {
                    let start = moment(e.start).subtract(diffSemaines, "week");
                    let end = moment(e.end).subtract(diffSemaines, "week");
                    e.start = start.format("YYYY-MM-DDTHH:mm:ss");
                    e.end = end.format("YYYY-MM-DDTHH:mm:ss");
                  }
                });
              }
            }
          } else if (dateNow < startplan) {
            const diffMs = Math.abs(startplan - dateNow); // différence en millisecondes
            const diffJours = diffMs / (1000 * 60 * 60 * 24); // en jours
            let diffSemaines = Math.floor(diffJours / 7);
            diffSemaines = diffSemaines + 1;

            if (this.dayWeekPlanning == false) {
              if (this.calendarOptions.events != null) {
                this.calendarOptions.events.forEach((e) => {
                  if (e.type == "boite") {
                    if (
                      moment(e.start).add(1, "day").format("YYYY-MM-DD") ==
                      moment(calendarApi.getDate().toString()).format(
                        "YYYY-MM-DD",
                      )
                    ) {
                      let start = moment(e.start).add(diffSemaines, "week");
                      let end = moment(e.end).add(diffSemaines, "week");
                      e.start = start.format("YYYY-MM-DDTHH:mm:ss");
                      e.end = end.format("YYYY-MM-DDTHH:mm:ss");
                    }
                  }
                });
              }
            } else {
              if (this.calendarOptions.events != null) {
                this.calendarOptions.events.forEach((e) => {
                  if (e.type == "boite") {
                    let startBoite = moment(e.start).add(diffSemaines, "week");
                    let endBoite = moment(e.end).add(diffSemaines, "week");
                    e.start = startBoite.format("YYYY-MM-DDTHH:mm:ss");
                    e.end = endBoite.format("YYYY-MM-DDTHH:mm:ss");
                  }
                });
              }
            }
          }
        }
      } else {
        this.calendarOptions.events = this.calendarOptions.events.filter(
          (e) => e.type != "creneaudispo",
        );
        this.calendarOptions.events = this.calendarOptions.events.filter(
          (e) => e.type != "creneauindispo",
        );
      }
    },

    setupLieuDispo(lieuSelec) {
      this.lieu = lieuSelec;
    },

    getEleveInfoChange(date, planningForm) {
      window.api
        .post(
          "/eleve/conduite/" + this.$store.state.user.id + "/changeplan",
          {
            date: date,
            planningForm: planningForm,
          },
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          },
        )
        .then((response) => {
          this.$store.commit("setElevePlanningInfo", response.data.eleve[0]);
          if (this.eleve.choixDispo == "null") {
            this.$store.commit("setShowMonoElevePage", true);
          }

          this.putOnPlanningEleve();

          if (this.monoResa != "") {
            // Recharge toujours les créneaux dispo/indispo pour la semaine affichée,
            // même si le moniteur choisi n'apparaît pas dans le monoChoix de cette semaine
            this.getHeuresResaWeek();

            let findMono = null;
            findMono = response.data.eleve[0].monoChoix.find(
              (e) => e.idMono == this.monoResa,
            );
            if (findMono != undefined) {
              this.setupMonoChoice(findMono);
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    putOnPlanningEleve() {
      if (this.calendarOptions.events.length != 0) {
        this.calendarOptions.events = this.calendarOptions.events.filter(
          (e) => e.type != "creneaudispo",
        );
      }

      if (this.calendarOptions.events.length != 0) {
        this.calendarOptions.events = this.calendarOptions.events.filter(
          (e) => e.type != "creneauindispo",
        );
      }

      if (this.calendarOptions.events.length != 0) {
        this.calendarOptions.events = this.calendarOptions.events.filter(
          (e) => e.type != "indispoEleve",
        );
      }

      if (this.calendarOptions.events.length != 0) {
        let filterEvent = this.calendarOptions.events.filter(
          (e) => e.type != "resa",
        );
        this.calendarOptions.events = filterEvent;
      }

      if (this.calendarOptions.events.length != 0) {
        let filterEvent = this.calendarOptions.events.filter(
          (e) => e.type != "exam",
        );
        this.calendarOptions.events = filterEvent;
      }

      if (this.calendarOptions.events.length != 0) {
        let filterEvent = this.calendarOptions.events.filter(
          (e) => e.type != "exam blanc",
        );
        this.calendarOptions.events = filterEvent;
      }

      this.$store.state.elevePlanningInfo.dispos.forEach((d) => {
        this.calendarOptions.events.push({
          id: d.id,
          title: "Dispo - " + d.lieu.nom,
          start: moment(d.start.date).format("YYYY-MM-DDTHH:mm:ss"),
          end: moment(d.end.date).format("YYYY-MM-DDTHH:mm:ss"),
          color: "blue",
          type: "dispo",
          display: this.$store.state.dispoOrResa == true ? "background" : "",
        });
      });

      this.$store.state.elevePlanningInfo.apointments.forEach((r) => {
        if (r.lieuFin.nom == "Cer impérativement") {
          let fin = r.lieuFin.nom.substring(3);
          r.lieuFin.nom = this.$store.state.elevePlanningInfo.agence.nom + fin;
        } else if (
          r.lieuFin.nom == "CER ou lieu début selon les besoins de l'agence"
        ) {
          let fin = r.lieuFin.nom.substring(18);
          r.lieuFin.nom =
            this.$store.state.elevePlanningInfo.agence.nom +
            " ou " +
            r.lieuDeb.nom +
            " " +
            fin;
        }

        let statAac = "";

        if (r.statAac != "null") {
          statAac = r.statAac;
        }

        if (r.motif == "null") {
          if (r.done) {
            this.calendarOptions.events.push({
              id: r.id,
              title: r.moniteur.fullname,
              start: moment(r.start.date).format("YYYY-MM-DDTHH:mm:ss"),
              end: moment(r.end.date).format("YYYY-MM-DDTHH:mm:ss"),
              color: "teal",
              type: "resa",
              done: true,
              editable: false,
              motif: false,
              dateResa: r.dateResa.date,
              resourceId: r.moniteur.idMoni,
              display: "background",
              lieuDeb: r.lieuDeb.nom,
              lieuFin: r.lieuFin.nom,
              statutAac: statAac,
            });
          } else {
            this.calendarOptions.events.push({
              id: r.id,
              title: r.moniteur.fullname,
              start: moment(r.start.date).format("YYYY-MM-DDTHH:mm:ss"),
              end: moment(r.end.date).format("YYYY-MM-DDTHH:mm:ss"),
              color: "green",
              type: "resa",
              done: false,
              editable: false,
              motif: false,
              dateResa: r.dateResa.date,
              resourceId: r.moniteur.idMoni,
              display: "background",
              lieuDeb: r.lieuDeb.nom,
              lieuFin: r.lieuFin.nom,
              statutAac: statAac,
            });
          }
        } else {
          if (r.typeMotif == "Eleve Absent") {
            let hDiff = this.diff_hours(
              new Date(r.start.date),
              new Date(r.cancelRdv.date),
            );

            let rStart = new Date(r.start.date);

            if (rStart.getDay() === 1 || rStart.getDay() === 2) {
              this.limitAnnulation = 48;
            } else {
              this.limitAnnulation = 48;
            }

            if (hDiff <= this.limitAnnulation) {
              this.calendarOptions.events.push({
                id: r.id,
                title: r.moniteur.fullname,
                start: moment(r.start.date).format("YYYY-MM-DDTHH:mm:ss"),
                end: moment(r.end.date).format("YYYY-MM-DDTHH:mm:ss"),
                color: "red",
                type: "resa",
                done: false,
                editable: false,
                motif: true,
                dateResa: r.dateResa.date,
                resourceId: r.moniteur.idMoni,
                display: "background",
                lieuDeb: r.lieuDeb.nom,
                lieuFin: r.lieuFin.nom,
                statutAac: statAac,
              });
            }
          } else if (r.typeMotif == "Mono Absent") {
            // Ne plus afficher les rdvs annulés avec le motif "Mono Absent"
          } else if (r.typeMotif == "Incident") {
            this.calendarOptions.events.push({
              id: r.id,
              title: r.moniteur.fullname + "motif : Incident - " + r.motif,
              start: moment(r.start.date).format("YYYY-MM-DDTHH:mm:ss"),
              end: moment(r.end.date).format("YYYY-MM-DDTHH:mm:ss"),
              color: "yellow",
              type: "resa",
              done: false,
              textColor: "black",
              editable: false,
              motif: true,
              dateResa: r.dateResa.date,
              resourceId: r.moniteur.idMoni,
              display: "background",
              lieuDeb: r.lieuDeb.nom,
              lieuFin: r.lieuFin.nom,
              statutAac: statAac,
            });
          }
        }
      });

      this.$store.state.elevePlanningInfo.exams.forEach((i) => {
        this.calendarOptions.events.push({
          id: i.id,
          title: "EXAM : " + i.boite,
          start: moment(i.start.date).format("YYYY-MM-DDTHH:mm:ss"),
          end: moment(i.end.date).format("YYYY-MM-DDTHH:mm:ss"),
          color: "pink",
          type: "exam",
          lieu: i.lieu.nom,
          mono: i.moniteur.surnom,
          rdv: this.$store.state.user.agence.nom,
        });
      });

      this.$store.state.elevePlanningInfo.examBlancs.forEach((i) => {
        this.calendarOptions.events.push({
          id: i.id,
          title: "EXAM BLANC : " + i.boite,
          start: moment(i.start.date).format("YYYY-MM-DDTHH:mm:ss"),
          end: moment(i.end.date).format("YYYY-MM-DDTHH:mm:ss"),
          color: "orange",
          type: "exam blanc",
          lieu: i.lieu.nom,
          mono: i.moniteur.surnom,
          rdv: this.$store.state.user.agence.nom,
        });
      });

      if (this.$store.state.dispoOrResa == true) {
        this.setDisplayResaDispo(true, false);
      }
    },

    eventhover(info) {
      const { event, el } = info;
      const props = event.extendedProps;

      // Tooltip natif (inchangé)
      el.title = event.title;

      // On ne touche pas aux events "background" (élève absent, dispos…)
      if (event.display === "background") return;

      // Uniquement les types qu'on veut enrichir
      const enrichTypes = ["resa", "exam", "exam blanc", "indispo"];
      if (!enrichTypes.includes(props.type)) return;

      // Récupère le conteneur principal généré par FullCalendar
      const inner = el.querySelector(".fc-event-main");
      if (!inner) return;

      // Vide le contenu par défaut
      inner.innerHTML = "";

      // ── Heure ──
      const timeEl = document.createElement("div");
      timeEl.className = "ev-time";
      timeEl.textContent = info.timeText;
      inner.appendChild(timeEl);

      // ── Titre (nom élève / label event) ──
      const titleEl = document.createElement("div");
      titleEl.className = "ev-title";
      titleEl.textContent = event.title;
      inner.appendChild(titleEl);

      // ── Lieu début (uniquement pour les resas) ──
      if (props.lieuDeb) {
        const debEl = document.createElement("div");
        debEl.className = "ev-meta";
        debEl.textContent = "deb : " + props.lieuDeb;
        inner.appendChild(debEl);
        el.title = el.title + " | " + "deb : " + props.lieuDeb;
      }

      // ── Lieu fin ──
      if (props.lieuFin) {
        const finEl = document.createElement("div");
        finEl.className = "ev-meta";
        finEl.textContent = "fin : " + props.lieuFin;
        inner.appendChild(finEl);
        el.title = el.title + " | " + "fin : " + props.lieuFin;
      }

      if (props.lieu) {
        const elieu = document.createElement("div");
        elieu.className = "ev-meta";
        elieu.textContent = props.lieu;
        inner.appendChild(elieu);
        el.title = el.title + " | " + "lieu : " + props.lieu;
      }

      if (props.mono) {
        const mono = document.createElement("div");
        mono.className = "ev-meta";
        mono.textContent = "Moniteur : " + props.mono;
        inner.appendChild(mono);
        el.title = el.title + " | mono : " + props.mono;
      }

      if (props.rdv) {
        const rdv = document.createElement("div");
        rdv.className = "ev-meta";
        rdv.textContent = " RDV : " + props.rdv;
        inner.appendChild(rdv);
        el.title = el.title + " | " + "RDV à : " + props.rdv;
      }

      // ── Badge statut AAC si présent ──
      if (props.statutAac && props.statutAac !== "null") {
        const aacEl = document.createElement("span");
        aacEl.className = "ev-badge";
        aacEl.textContent = props.statutAac;
        inner.appendChild(aacEl);
      }
    },

    putDispoEleve(arg) {
      if (
        arg.event["_def"].title.substring(0, 5) == "Dispo" &&
        this.$store.state.dispoOrResa == false
      ) {
        window.api
          .put(
            "/disponibilites/" + arg.event._def.publicId,
            {
              start: arg.event._instance.range.start,
              end: arg.event._instance.range.end,
              eleve: "api/utilisateurs/" + this.$store.state.user.id,
            },
            {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            },
          )
          .then(() => {})
          .catch((error) => {
            console.log(error);
          });
      }
    },

    goBackInStep() {
      if (this.step != 1) {
        this.step = this.step - 1;

        if (this.step == 1) {
          document.getElementById("stepTwo").classList.remove("active");
          document.getElementById("stepOne").classList.remove("inactive");
          document.getElementById("stepTwo").classList.add("inactive");
          document.getElementById("stepOne").classList.add("active");
        } else if (this.step == 2) {
          document.getElementById("stepThree").classList.remove("active");
          document.getElementById("stepTwo").classList.remove("inactive");
          document.getElementById("stepThree").classList.add("inactive");
          document.getElementById("stepTwo").classList.add("active");
        }
      }
    },

    handleCloseResa() {
      this.gpLieuxFin = [];
      this.lieuxFin = [];
    },

    setDisplayResaDispo(show, resetSelection = true) {
      if (resetSelection) {
        this.monoResa = "";
        this.apMono = null;
      }

      if (this.calendarOptions.events.length != 0) {
        this.calendarOptions.events = this.calendarOptions.events.filter(
          (e) => e.type != "creneaudispo",
        );
      }

      if (this.calendarOptions.events.length != 0) {
        this.calendarOptions.events = this.calendarOptions.events.filter(
          (e) => e.type != "creneauindispo",
        );
      }

      if (this.calendarOptions.events.length != 0) {
        let filterEvent = this.calendarOptions.events.filter(
          (e) => e.type != "boite",
        );
        this.calendarOptions.events = filterEvent;
      }

      if (show) {
        this.hideSelectDispo = false;
        this.calendarOptions.events.forEach((event) => {
          if (event.type === "dispo") {
            event.display = "background";
          }
        });

        this.calendarOptions.events.forEach((event) => {
          if (event.type === "resa") {
            event.display = "";
          }
        });
      } else {
        this.hideSelectDispo = true;
        this.calendarOptions.events.forEach((event) => {
          if (event.type === "dispo") {
            event.display = "";
          }
        });

        this.calendarOptions.events.forEach((event) => {
          if (event.type === "resa") {
            event.display = "background";
          }
        });
      }
    },

    setResaWeek() {
      let resaInfo = { startStr: "null", endStr: "null" };
      resaInfo.startStr = this.selectEvent["event"]["start"];
      resaInfo.endStr = this.selectEvent["event"]["end"];

      window.api
        .post(
          "/check/limit/hour/" + this.$store.state.user.id,
          {
            date: moment(resaInfo.startStr).format("YYYY-MM-DDTHH:mm:ss"),
            start: moment(resaInfo.startStr).format("YYYY-MM-DDTHH:mm:ss"),
            end: moment(resaInfo.endStr).format("YYYY-MM-DDTHH:mm:ss"),
          },
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          },
        )
        .then((r) => {
          if (r.data.limit) {
            window.api
              .post(
                "/eleves/cansimu/" + this.$store.state.user.id,
                {
                  start: moment(resaInfo.startStr).format(
                    "YYYY-MM-DDTHH:mm:ss",
                  ),
                  mono: this.monoResa,
                },
                {
                  headers: {
                    Authorization: "Bearer " + this.$store.state.token,
                  },
                },
              )
              .then((r) => {
                let cantSimu = null;
                cantSimu = r.data.eleves[0].nbRdv;

                if (cantSimu == false || cantSimu <= 0) {
                  let nowDate = new Date();
                  window.api
                    .post(
                      "/set/apointment/" +
                        this.$store.state.user.id +
                        "/" +
                        this.monoResa +
                        "/" +
                        this.$store.state.lieuDebResaEleve +
                        "/" +
                        this.$store.state.lieuFinResaEleve +
                        "/eleve",
                      {
                        start: moment(resaInfo.startStr).format(
                          "YYYY-MM-DDTHH:mm:ss",
                        ),
                        end: moment(resaInfo.endStr).format(
                          "YYYY-MM-DDTHH:mm:ss",
                        ),
                        now: moment(nowDate.date).format("YYYY-MM-DDTHH:mm:ss"),
                      },
                      {
                        headers: {
                          Authorization: "Bearer " + this.$store.state.token,
                        },
                      },
                    )
                    .then((response) => {
                      if (response.data.fin == "Cer impérativement") {
                        let fin = response.data.fin.substring(3);
                        response.data.fin =
                          this.$store.state.elevePlanningInfo.agence.nom + fin;
                      } else if (
                        response.data.fin ==
                        "CER ou lieu début selon les besoins de l'agence"
                      ) {
                        let fin = response.data.fin.substring(18);
                        response.data.fin =
                          this.$store.state.elevePlanningInfo.agence.nom +
                          " ou " +
                          response.data.deb +
                          " " +
                          fin;
                      }

                      if (response.data.message == "Solde insufisant") {
                        this.showSoldeInsuffisantDialog = true;
                        this.loadResaBtn = false;
                        this.$emit("clearValuesResa");
                      } else if (
                        response.data.message ==
                        "Le moniteur choisi n'est pas disponible sur le créneau voulu"
                      ) {
                        alert(response.data.message);
                        this.loadResaBtn = false;
                        this.loadResaBtn = false;
                        this.$emit("clearValuesResa");
                      } else if (
                        response.data.message ==
                        "Vous ne pouvez pas réserver plus de 2 d'affilées"
                      ) {
                        alert(response.data.message);
                        this.loadResaBtn = false;
                        this.$emit("clearValuesResa");
                      } else {
                        this.loadResaBtn = false;

                        let creneauDispo = this.calendarOptions.events.filter(
                          (e) => e.type != "creneaudispo",
                        );
                        this.calendarOptions.events = creneauDispo;

                        this.calendarOptions.events.push({
                          id: response.data.apointment,
                          title: response.data.moniteur,
                          lieuDeb: response.data.deb,
                          lieuFin: response.data.fin,
                          statutAac: response.data.statutAac && response.data.statutAac !== "null" ? response.data.statutAac : "",
                          start: moment(resaInfo.startStr).format(
                            "YYYY-MM-DDTHH:mm:ss",
                          ),
                          end: moment(resaInfo.endStr).format(
                            "YYYY-MM-DDTHH:mm:ss",
                          ),
                          color: "green",
                          type: "resa",
                          done: false,
                          editable: false,
                          motif: false,
                          resourceId: this.monoResa,
                          dateResa: response.data.dateResa.date,
                        });

                        if (response.data.indisposResa.length > 0) {
                          response.data.indisposResa.forEach((i) => {
                            this.calendarOptions.events.push({
                              id: i.id,
                              title: "INDISPO",
                              start: moment(i.start.date).format(
                                "YYYY-MM-DDTHH:mm:ss",
                              ),
                              end: moment(i.end.date).format(
                                "YYYY-MM-DDTHH:mm:ss",
                              ),
                              color: "grey",
                              type: "indispoEleve",
                            });
                          });
                        }
                      }
                      if (this.apMono && this.apMono.surnom === "Simu") {
                        this.simuHoursRemaining -= (this.eleve.agence.dureeHeure || 2);
                        if (this.simuHoursRemaining <= 0) {
                          this.showSimuDoneDialog = true;
                        }
                      }
                      this.getHeuresResaWeek();
                      this.$emit("getEleveInfo");
                      this.showResaMod = false;
                      this.lieuxDeb = [];
                      this.lieuxFin = null;
                      this.lieuFinChoix = null;
                      this.$emit("clearValuesResa");
                      window.api
                        .post(
                          "/sendMail",
                          {
                            type: "rdv ok",
                            id: response.data.apointment,
                            email: response.data.eleveMail,
                          },
                          {
                            headers: {
                              Authorization:
                                "Bearer " + this.$store.state.token,
                            },
                          },
                        )
                        .then(() => {})
                        .catch((error) => {
                          console.log(error);
                        });
                    })
                    .catch((error) => {
                      console.log(error);
                    });

                  this.toast.add({
                    severity: "success",
                    summary: "RDV ajouté",
                    detail: "",
                    life: 3000,
                  });
                } else {
                  if (this.apMono.surnom !== "Simu") {
                    let alertMsg = "";
                    let nbHeure = "4";

                    if (cantSimu == "not") {
                      alertMsg =
                        "Vous ne pouvez pas réserver un cours avec un moniteur avant que les " +
                        nbHeure +
                        " heures obligatoires sur simulateur pour cet élève soient effectuées";
                    } else {
                      alertMsg =
                        "Cet élève doit faire " +
                        nbHeure +
                        "h de simulateur minimum avant de pouvoir conduire avec un moniteur (" +
                        cantSimu +
                        "h restantes)";
                    }

                    alert(alertMsg);
                    this.loadResaBtn = false;
                    this.$emit("clearValuesResa");
                    this.$emit("getEleveInfo");
                    this.showResaMod = false;
                    this.lieuxDeb = [];
                    this.lieuxFin = null;
                    this.lieuFinChoix = null;
                  } else {
                    let nowDate = new Date();
                    window.api
                      .post(
                        "/set/apointment/" +
                          this.$store.state.user.id +
                          "/" +
                          this.monoResa +
                          "/" +
                          this.$store.state.lieuDebResaEleve +
                          "/" +
                          this.$store.state.lieuFinResaEleve +
                          "/eleve",
                        {
                          start: moment(resaInfo.startStr).format(
                            "YYYY-MM-DDTHH:mm:ss",
                          ),
                          end: moment(resaInfo.endStr).format(
                            "YYYY-MM-DDTHH:mm:ss",
                          ),
                          now: moment(nowDate.date).format(
                            "YYYY-MM-DDTHH:mm:ss",
                          ),
                        },
                        {
                          headers: {
                            Authorization: "Bearer " + this.$store.state.token,
                          },
                        },
                      )
                      .then((response) => {
                        if (response.data.fin == "Cer impérativement") {
                          let fin = response.data.fin.substring(3);
                          response.data.fin =
                            this.$store.state.elevePlanningInfo.agence.nom +
                            fin;
                        } else if (
                          response.data.fin ==
                          "CER ou lieu début selon les besoins de l'agence"
                        ) {
                          let fin = response.data.fin.substring(18);
                          response.data.fin =
                            this.$store.state.elevePlanningInfo.agence.nom +
                            " ou " +
                            response.data.deb +
                            " " +
                            fin;
                        }

                        if (response.data.message == "Solde insufisant") {
                          this.showSoldeInsuffisantDialog = true;
                          this.loadResaBtn = false;
                          this.$emit("clearValuesResa");
                        } else if (
                          response.data.message ==
                          "Le moniteur choisi n'est pas disponible sur le créneau voulu"
                        ) {
                          alert(response.data.message);
                          this.loadResaBtn = false;
                          this.$emit("clearValuesResa");
                        } else if (
                          response.data.message ==
                          "Vous ne pouvez pas réserver plus de 2 d'affilées"
                        ) {
                          alert(response.data.message);
                          this.$emit("clearValuesResa");
                        } else {
                          this.loadResaBtn = false;
                          let creneauDispo = this.calendarOptions.events.filter(
                            (e) => e.type != "creneaudispo",
                          );
                          this.calendarOptions.events = creneauDispo;
                          this.calendarOptions.events.push({
                            id: response.data.apointment,
                            title: response.data.moniteur,
                              lieuDeb: response.data.deb,
                              lieuFin: response.data.fin,
                            start: moment(resaInfo.startStr).format(
                              "YYYY-MM-DDTHH:mm:ss",
                            ),
                            end: moment(resaInfo.endStr).format(
                              "YYYY-MM-DDTHH:mm:ss",
                            ),
                            color: "green",
                            type: "resa",
                            done: false,
                            editable: false,
                            motif: false,
                            resourceId: this.monoResa,
                            dateResa: response.data.dateResa.date,
                          });

                          if (response.data.indisposResa.length > 0) {
                            response.data.indisposResa.forEach((i) => {
                              this.calendarOptions.events.push({
                                id: i.id,
                                title: "INDISPO",
                                start: moment(i.start.date).format(
                                  "YYYY-MM-DDTHH:mm:ss",
                                ),
                                end: moment(i.end.date).format(
                                  "YYYY-MM-DDTHH:mm:ss",
                                ),
                                color: "grey",
                                type: "indispoEleve",
                              });
                            });
                          }
                        }
                        this.simuHoursRemaining -= (this.eleve.agence.dureeHeure || 2);
                        if (this.simuHoursRemaining <= 0) {
                          this.showSimuDoneDialog = true;
                        }
                        this.getHeuresResaWeek();
                        this.$emit("getEleveInfo");
                        this.showResaMod = false;
                        this.lieuxDeb = [];
                        this.lieuxFin = null;
                        this.lieuFinChoix = null;
                        this.$emit("clearValuesResa");
                        window.api
                          .post(
                            "/sendMail",
                            {
                              type: "rdv ok",
                              id: response.data.apointment,
                              email: response.data.eleveMail,
                            },
                            {
                              headers: {
                                Authorization:
                                  "Bearer " + this.$store.state.token,
                              },
                            },
                          )
                          .then(() => {})
                          .catch((error) => {
                            console.log(error);
                          });
                      })
                      .catch((error) => {
                        console.log(error);
                      });

                    this.toast.add({
                      severity: "success",
                      summary: "RDV ajouté",
                      detail: "",
                      life: 3000,
                    });
                  }
                }
              })
              .catch((error) => {
                console.log(error);
              });
          } else {
            alert(
              "Vous êtes à la limite d'heure par semaine autorisé par votre agence, Si vous voulez réserver plus d'heure cette semaine passer en formation accélérée.",
            );
            this.loadResaBtn = false;
            this.$emit("clearValuesResa");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    setResa() {
      this.loadResaBtn = true;
      if (
        this.monoResa == "" ||
        this.$store.state.lieuDebResaEleve == null ||
        this.$store.state.lieuFinResaEleve == null
      ) {
        alert(
          "Veuillez saisir un moniteur, lieu de début et un lieu de fin pour votre cours",
        );
        this.loadResaBtn = false;
      } else {
        let resaInfo = { startStr: "null", endStr: "null" };
        resaInfo.startStr = "";
        resaInfo.endStr = "";

        if (this.eleve.agence.dureeHeure == 1) {
          resaInfo = this.selectEvent;
        } else {
          resaInfo.startStr =
            this.$store.state.dateResa +
            "T" +
            this.$store.state.creneauResa.start +
            ":00:00";
          resaInfo.endStr =
            this.$store.state.dateResa +
            "T" +
            this.$store.state.creneauResa.end +
            ":00:00";
        }

        window.api
          .post(
            "/check/limit/hour/" + this.$store.state.user.id,
            {
              date: moment(resaInfo.startStr).format("YYYY-MM-DDTHH:mm:ss"),
              start: moment(resaInfo.startStr).format("YYYY-MM-DDTHH:mm:ss"),
              end: moment(resaInfo.endStr).format("YYYY-MM-DDTHH:mm:ss"),
            },
            {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            },
          )
          .then((r) => {
            if (r.data.limit) {
              window.api
                .post(
                  "/eleves/cansimu/" + this.$store.state.user.id,
                  {
                    start: moment(resaInfo.startStr).format(
                      "YYYY-MM-DDTHH:mm:ss",
                    ),
                    mono: this.monoResa,
                  },
                  {
                    headers: {
                      Authorization: "Bearer " + this.$store.state.token,
                    },
                  },
                )
                .then((r) => {
                  let cantSimu = null;
                  cantSimu = r.data.eleves[0].nbRdv;

                  if (cantSimu == false || cantSimu <= 0) {
                    let nowDate = new Date();
                    window.api
                      .post(
                        "/set/apointment/" +
                          this.$store.state.user.id +
                          "/" +
                          this.monoResa +
                          "/" +
                          this.$store.state.lieuDebResaEleve +
                          "/" +
                          this.$store.state.lieuFinResaEleve +
                          "/eleve",
                        {
                          start: moment(resaInfo.startStr).format(
                            "YYYY-MM-DDTHH:mm:ss",
                          ),
                          end: moment(resaInfo.endStr).format(
                            "YYYY-MM-DDTHH:mm:ss",
                          ),
                          now: moment(nowDate.date).format(
                            "YYYY-MM-DDTHH:mm:ss",
                          ),
                        },
                        {
                          headers: {
                            Authorization: "Bearer " + this.$store.state.token,
                          },
                        },
                      )
                      .then((response) => {
                        if (response.data.fin == "Cer impérativement") {
                          let fin = response.data.fin.substring(3);
                          response.data.fin =
                            this.$store.state.elevePlanningInfo.agence.nom +
                            fin;
                        } else if (
                          response.data.fin ==
                          "CER ou lieu début selon les besoins de l'agence"
                        ) {
                          let fin = response.data.fin.substring(18);
                          response.data.fin =
                            this.$store.state.elevePlanningInfo.agence.nom +
                            " ou " +
                            response.data.deb +
                            " " +
                            fin;
                        }

                        if (response.data.message == "Solde insufisant") {
                          this.showSoldeInsuffisantDialog = true;
                          this.loadResaBtn = false;
                          this.$emit("clearValuesResa");
                        } else if (
                          response.data.message ==
                          "Le moniteur choisi n'est pas disponible sur le créneau voulu"
                        ) {
                          alert(response.data.message);
                          this.loadResaBtn = false;
                          this.loadResaBtn = false;
                          this.$emit("clearValuesResa");
                        } else if (
                          response.data.message ==
                          "Vous ne pouvez pas réserver plus de 2 d'affilées"
                        ) {
                          alert(response.data.message);
                          this.loadResaBtn = false;
                          this.$emit("clearValuesResa");
                        } else {
                          this.loadResaBtn = false;
                          this.calendarOptions.events.push({
                            id: response.data.apointment,
                            title: response.data.moniteur,
                              lieuDeb: response.data.deb,
                              lieuFin: response.data.fin,
                            start: moment(resaInfo.startStr).format(
                              "YYYY-MM-DDTHH:mm:ss",
                            ),
                            end: moment(resaInfo.endStr).format(
                              "YYYY-MM-DDTHH:mm:ss",
                            ),
                            color: "green",
                            type: "resa",
                            done: false,
                            editable: false,
                            motif: false,
                            resourceId: this.monoResa,
                            dateResa: response.data.dateResa.date,
                          });

                          if (response.data.indisposResa.length > 0) {
                            response.data.indisposResa.forEach((i) => {
                              this.calendarOptions.events.push({
                                id: i.id,
                                title: "INDISPO",
                                start: moment(i.start.date).format(
                                  "YYYY-MM-DDTHH:mm:ss",
                                ),
                                end: moment(i.end.date).format(
                                  "YYYY-MM-DDTHH:mm:ss",
                                ),
                                color: "grey",
                                type: "indispoEleve",
                              });
                            });
                          }
                        }
                        if (this.apMono && this.apMono.surnom === "Simu") {
                          this.simuHoursRemaining -= (this.eleve.agence.dureeHeure || 2);
                          if (this.simuHoursRemaining <= 0) {
                            this.showSimuDoneDialog = true;
                          }
                        }
                        this.$emit("getEleveInfo");
                        this.showResaMod = false;
                        this.lieuxDeb = [];
                        this.lieuxFin = null;
                        this.lieuFinChoix = null;
                        this.$emit("clearValuesResa");
                        window.api
                          .post(
                            "/sendMail",
                            {
                              type: "rdv ok",
                              id: response.data.apointment,
                              email: response.data.eleveMail,
                            },
                            {
                              headers: {
                                Authorization:
                                  "Bearer " + this.$store.state.token,
                              },
                            },
                          )
                          .then(() => {})
                          .catch((error) => {
                            console.log(error);
                          });
                      })
                      .catch((error) => {
                        console.log(error);
                      });

                    this.toast.add({
                      severity: "success",
                      summary: "RDV ajouté",
                      detail: "",
                      life: 3000,
                    });
                  } else {
                    if (this.apMono.surnom !== "Simu") {
                      let alertMsg = "";
                      let nbHeure = "4";

                      if (cantSimu == "not") {
                        alertMsg =
                          "Vous ne pouvez pas réserver un cours avec un moniteur avant que les " +
                          nbHeure +
                          " heures obligatoires sur simulateur pour cet élève soient effectuées";
                      } else {
                        alertMsg =
                          "Cet élève doit faire " +
                          nbHeure +
                          "h de simulateur minimum avant de pouvoir conduire avec un moniteur (" +
                          cantSimu +
                          "h restantes)";
                      }

                      alert(alertMsg);
                      this.loadResaBtn = false;
                      this.$emit("clearValuesResa");
                      this.$emit("getEleveInfo");
                      this.showResaMod = false;
                      this.lieuxDeb = [];
                      this.lieuxFin = null;
                      this.lieuFinChoix = null;
                    } else {
                      let nowDate = new Date();
                      window.api
                        .post(
                          "/set/apointment/" +
                            this.$store.state.user.id +
                            "/" +
                            this.monoResa +
                            "/" +
                            this.$store.state.lieuDebResaEleve +
                            "/" +
                            this.$store.state.lieuFinResaEleve +
                            "/eleve",
                          {
                            start: moment(resaInfo.startStr).format(
                              "YYYY-MM-DDTHH:mm:ss",
                            ),
                            end: moment(resaInfo.endStr).format(
                              "YYYY-MM-DDTHH:mm:ss",
                            ),
                            now: moment(nowDate.date).format(
                              "YYYY-MM-DDTHH:mm:ss",
                            ),
                          },
                          {
                            headers: {
                              Authorization:
                                "Bearer " + this.$store.state.token,
                            },
                          },
                        )
                        .then((response) => {
                          if (response.data.fin == "Cer impérativement") {
                            let fin = response.data.fin.substring(3);
                            response.data.fin =
                              this.$store.state.elevePlanningInfo.agence.nom +
                              fin;
                          } else if (
                            response.data.fin ==
                            "CER ou lieu début selon les besoins de l'agence"
                          ) {
                            let fin = response.data.fin.substring(18);
                            response.data.fin =
                              this.$store.state.elevePlanningInfo.agence.nom +
                              " ou " +
                              response.data.deb +
                              " " +
                              fin;
                          }

                          if (response.data.message == "Solde insufisant") {
                            this.showSoldeInsuffisantDialog = true;
                            this.loadResaBtn = false;
                            this.$emit("clearValuesResa");
                          } else if (
                            response.data.message ==
                            "Le moniteur choisi n'est pas disponible sur le créneau voulu"
                          ) {
                            alert(response.data.message);
                            this.loadResaBtn = false;
                            this.$emit("clearValuesResa");
                          } else if (
                            response.data.message ==
                            "Vous ne pouvez pas réserver plus de 2 d'affilées"
                          ) {
                            alert(response.data.message);
                            this.$emit("clearValuesResa");
                          } else {
                            this.loadResaBtn = false;
                            this.calendarOptions.events.push({
                              id: response.data.apointment,
                              title: response.data.moniteur,
                              lieuDeb: response.data.deb,
                              lieuFin: response.data.fin,
                              start: moment(resaInfo.startStr).format(
                                "YYYY-MM-DDTHH:mm:ss",
                              ),
                              end: moment(resaInfo.endStr).format(
                                "YYYY-MM-DDTHH:mm:ss",
                              ),
                              color: "green",
                              type: "resa",
                              done: false,
                              editable: false,
                              motif: false,
                              resourceId: this.monoResa,
                              dateResa: response.data.dateResa.date,
                            });

                            if (response.data.indisposResa.length > 0) {
                              response.data.indisposResa.forEach((i) => {
                                this.calendarOptions.events.push({
                                  id: i.id,
                                  title: "INDISPO",
                                  start: moment(i.start.date).format(
                                    "YYYY-MM-DDTHH:mm:ss",
                                  ),
                                  end: moment(i.end.date).format(
                                    "YYYY-MM-DDTHH:mm:ss",
                                  ),
                                  color: "grey",
                                  type: "indispoEleve",
                                });
                              });
                            }
                          }
                          this.simuHoursRemaining -= (this.eleve.agence.dureeHeure || 2);
                          if (this.simuHoursRemaining <= 0) {
                            this.showSimuDoneDialog = true;
                          }
                          this.$emit("getEleveInfo");
                          this.showResaMod = false;
                          this.lieuxDeb = [];
                          this.lieuxFin = null;
                          this.lieuFinChoix = null;
                          this.$emit("clearValuesResa");
                          window.api
                            .post(
                              "/sendMail",
                              {
                                type: "rdv ok",
                                id: response.data.apointment,
                                email: response.data.eleveMail,
                              },
                              {
                                headers: {
                                  Authorization:
                                    "Bearer " + this.$store.state.token,
                                },
                              },
                            )
                            .then(() => {})
                            .catch((error) => {
                              console.log(error);
                            });
                        })
                        .catch((error) => {
                          console.log(error);
                        });

                      this.toast.add({
                        severity: "success",
                        summary: "RDV ajouté",
                        detail: "",
                        life: 3000,
                      });
                    }
                  }
                })
                .catch((error) => {
                  console.log(error);
                });
            } else {
              alert(
                "Vous êtes à la limite d'heure par semaine autorisé par votre agence, Si vous voulez réserver plus d'heure cette semaine passer en formation accélérée.",
              );
              this.loadResaBtn = false;
              this.$emit("clearValuesResa");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    getLieuFin() {
      if (this.lieuDeb != null) {
        if (this.firstCours) {
          let lDeb = this.lieuxDeb.find((l) => l.id == this.lieuDeb);

          this.lieuxFin = this.firstCoursFin;
          let findGp1 = false;
          let findGp2 = false;
          let findGp3 = false;

          this.lieuxFin.forEach((l) => {
            if (lDeb.groupe == 3) {
              if (l.groupe == 1) {
                if (!findGp1) {
                  findGp1 = true;
                  this.gpLieuxFin.push(1);
                }
              }

              if (l.groupe == 2) {
                if (!findGp2) {
                  findGp2 = true;
                  this.gpLieuxFin.push(2);
                }
              }

              if (l.groupe == 3) {
                if (!findGp3) {
                  findGp3 = true;
                  this.gpLieuxFin.push(3);
                }
              }
            } else {
              if (l.groupe == 1) {
                if (!findGp1) {
                  findGp1 = true;
                  this.gpLieuxFin.push(1);
                }
              }

              if (l.groupe == 2) {
                if (!findGp2) {
                  findGp2 = true;
                  this.gpLieuxFin.push(2);
                }
              }
            }
          });
          document.getElementById("stepTwo").classList.remove("active");
          document.getElementById("stepThree").classList.remove("inactive");
          document.getElementById("stepTwo").classList.add("inactive");
          document.getElementById("stepThree").classList.add("active");
          this.step = 3;
        } else {
          window.api
            .post(
              "get/lieux/" + this.monoResa + "/resa/" + this.lieuDeb,
              {
                start: moment(this.selectEvent.startStr).format(
                  "YYYY-MM-DDTHH:mm:ss",
                ),
                end: moment(this.selectEvent.endStr).format(
                  "YYYY-MM-DDTHH:mm:ss",
                ),
              },
              {
                headers: {
                  Authorization: "Bearer " + this.$store.state.token,
                },
              },
            )
            .then((response) => {
              this.lieuxFin = response.data.fin;

              let findGp1 = false;
              let findGp2 = false;
              let findGp3 = false;
              this.lieuxFin.forEach((l) => {
                if (l.groupe == 1) {
                  if (!findGp1) {
                    findGp1 = true;
                    this.gpLieuxFin.push(1);
                  }
                }

                if (l.groupe == 2) {
                  if (!findGp2) {
                    findGp2 = true;
                    this.gpLieuxFin.push(2);
                  }
                }

                if (l.groupe == 3) {
                  if (!findGp3) {
                    findGp3 = true;
                    this.gpLieuxFin.push(3);
                  }
                }
              });

              document.getElementById("stepTwo").classList.remove("active");
              document.getElementById("stepThree").classList.remove("inactive");
              document.getElementById("stepTwo").classList.add("inactive");
              document.getElementById("stepThree").classList.add("active");
              this.step = 3;
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }
    },

    choixMonoResa() {
      window.api
        .post(
          "/get/lieux/" + this.monoResa + "/resa",
          {
            start: moment(this.selectEvent.startStr).format(
              "YYYY-MM-DDTHH:mm:ss",
            ),
            end: moment(this.selectEvent.endStr).format("YYYY-MM-DDTHH:mm:ss"),
          },
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          },
        )
        .then((r) => {
          r.data.deb.forEach((l) => {
            this.$store.state.elevePlanningInfo.choixDispo[0].choix.forEach(
              (c) => {
                if (c.id == this.monoResa) {
                  if (c.lieux != undefined) {
                    c.lieux.forEach((li) => {
                      if (l.id == li) {
                        l.choixEleve = true;
                      }
                    });
                  }
                }
              },
            );
          });

          this.lieuxDeb = r.data.deb;
          this.firstCours = r.data.first;
          this.firstCoursFin = r.data.fin;
          this.boiteResa = r.data.boite;
          document.getElementById("stepOne").classList.remove("active");
          document.getElementById("stepTwo").classList.remove("inactive");
          document.getElementById("stepOne").classList.add("inactive");
          document.getElementById("stepTwo").classList.add("active");
          this.step = 2;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getMoniteurs() {
      window.api
        .get(
          "/moniteurs/agence/planning/" +
            this.$store.state.user.agence.id +
            "/null",
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          },
        )
        .then((response) => {
          this.moniteurs = response.data.moniteurs;

          if (this.$store.state.elevePlanningInfo.choixDispo != "null") {
            this.moniteurs.forEach((m) => {
              this.$store.state.elevePlanningInfo.choixDispo[0].choix.forEach(
                (c) => {
                  if (c.id == m.idMono) {
                    m.choixEleve = true;
                  }
                },
              );
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    setDispo() {
      this.loadDispoBtn = true;
      if (this.lieu == "") {
        alert("Veuillez saisir un lieu pour votre disponibilité");
        this.loadDispoBtn = false;
      } else {
        window.api
          .post(
            "/disponibilites",
            {
              start: moment(this.selectEvent.startStr).format(
                "YYYY-MM-DDTHH:mm:ss",
              ),
              end: moment(this.selectEvent.endStr).format(
                "YYYY-MM-DDTHH:mm:ss",
              ),
              eleve: "api/utilisateurs/" + this.$store.state.user.id,
              lieu: "api/lieus/" + this.lieu,
            },
            {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            },
          )
          .then((response) => {
            this.loadDispoBtn = false;

            let lieuFind = this.lieuxDispo.find((l) => l.id == this.lieu);
            this.calendarOptions.events.push({
              id: response.data.id,
              title: "Dispo - " + lieuFind.nom,
              start: moment(this.selectEvent.startStr).format(
                "YYYY-MM-DDTHH:mm:ss",
              ),
              end: moment(this.selectEvent.endStr).format(
                "YYYY-MM-DDTHH:mm:ss",
              ),
              color: "blue",
              type: "dispo",
            });
            this.showDispoMod = false;

            this.toast.add({
              severity: "success",
              summary: "Disponibilité ajoutée",
              detail:
                "Veuillez cliquer sur le bouton agence pour prévenir votre agence du changement",
              life: 3000,
            });
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    setDispoMobile(dateDispo, heureDeb, heureFin, lieu) {
      this.$store.commit("setLoadDispoEleveBtn", true);

      let dispoInfo = { startStr: "null", endStr: "null" };
      dispoInfo.startStr = "";
      dispoInfo.endStr = "";

      dispoInfo.startStr = dateDispo + "T" + heureDeb;
      dispoInfo.endStr = dateDispo + "T" + heureFin;

      window.api
        .post(
          "/disponibilites",
          {
            start: moment(dispoInfo.startStr).format("YYYY-MM-DDTHH:mm:ss"),
            end: moment(dispoInfo.endStr).format("YYYY-MM-DDTHH:mm:ss"),
            eleve: "api/utilisateurs/" + this.$store.state.user.id,
            lieu: "api/lieus/" + lieu,
          },
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          },
        )
        .then((response) => {
          this.$store.commit("setLoadDispoEleveBtn", false);

          let lieuFind = this.lieuxDispo.find((l) => l.id == lieu);
          this.calendarOptions.events.push({
            id: response.data.id,
            title: "Dispo - " + lieuFind.nom,
            start: moment(dispoInfo.startStr).format("YYYY-MM-DDTHH:mm:ss"),
            end: moment(dispoInfo.endStr).format("YYYY-MM-DDTHH:mm:ss"),
            color: "blue",
            type: "dispo",
          });
          this.showDispoMod = false;

          this.toast.add({
            severity: "success",
            summary: "Disponibilité ajoutée",
            detail:
              "Veuillez cliquer sur le bouton agence pour prévenir votre agence du changement",
            life: 3000,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    handleDateClick(info) {
      if (this.$store.state.dispoOrResa || !this.isMobile) return;

      const now = Date.now();
      if (this.lastDateClick && now - this.lastDateClick < 500) return;
      this.lastDateClick = now;

      if (this.lieu === '') {
        alert("Veuillez d'abord choisir un lieu de disponibilité");
        return;
      }

      const clickedDate = info.date;

      if (this.mobileDispoStart === null) {
        this.mobileDispoStart = clickedDate;
        const ghostId = 'mobile-dispo-ghost';
        this.mobileDispoGhostId = ghostId;
        this.calendarOptions.events = this.calendarOptions.events.filter(e => e.id !== ghostId);
        this.calendarOptions.events.push({
          id: ghostId,
          title: 'Début dispo',
          start: moment(clickedDate).format('YYYY-MM-DDTHH:mm:ss'),
          end: moment(clickedDate).add(1, 'hour').format('YYYY-MM-DDTHH:mm:ss'),
          color: '#93c5fd',
          type: 'ghost',
        });
        this.toast.add({
          severity: 'info',
          summary: 'Début enregistré',
          detail: "Tapez maintenant sur l'heure de fin",
          life: 3000,
        });
      } else {
        if (moment(clickedDate).isSameOrBefore(moment(this.mobileDispoStart))) {
          alert("L'heure de fin doit être après le début");
          return;
        }

        if (this.mobileDispoGhostId) {
          this.calendarOptions.events = this.calendarOptions.events.filter(e => e.id !== this.mobileDispoGhostId);
        }

        this.selectEvent = {
          startStr: moment(this.mobileDispoStart).format('YYYY-MM-DDTHH:mm:ss'),
          endStr: moment(clickedDate).format('YYYY-MM-DDTHH:mm:ss'),
        };

        this.mobileDispoStart = null;
        this.mobileDispoGhostId = null;

        this.setDispo();
      }
    },

    getLieuxEleve() {
      window.api
        .get("/eleve/lieux/" + this.$store.state.user.id, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((response) => {
          response.data.lieux.forEach((l) => {
            let findL = null;
            findL = this.lieuxDispo.find((e) => e.id == l.id);
            if (findL == undefined) {
              this.lieuxDispo.push(l);
            }
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    selectAllow(select) {
      return moment().diff(select.start) <= 0;
    },

    deleteEvent(e) {
      if (e.event.display === "background") return;

      const eventStart = e["event"]["_instance"]["range"]["start"];
      if (eventStart < new Date()) return;

      this.selectEvent = e;

      let nowDate = new Date();
      if (
        e["event"]["_instance"]["range"]["start"].getDay() === 1 ||
        e["event"]["_instance"]["range"]["start"].getDay() === 2
      ) {
        this.limitAnnulation = 48;
      } else {
        this.limitAnnulation = 48;
      }
      this.hAnnulation = this.diff_hours(
        e["event"]["_instance"]["range"]["start"],
        nowDate,
      );
      let dateResa = new Date(e["event"]["_def"]["extendedProps"]["dateResa"]);
      dateResa.setHours(dateResa.getHours() + 1);

      this.limitGoBack = this.diffMinutes(dateResa, nowDate);

      // Parse en UTC pour éviter le décalage fuseau horaire (backend renvoie UTC sans marqueur)
      const dateResaUtc = moment.utc(e["event"]["_def"]["extendedProps"]["dateResa"]).toDate();
      const minutesSinceResa = this.diffMinutes(dateResaUtc, nowDate);

      if (e["event"]["_def"]["extendedProps"]["type"] == "dispo") {
        window.api
          .delete("/disponibilites/" + e.event["_def"].publicId, {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          })
          .then(() => {
            let events = [];
            this.calendarOptions.events.forEach((i) => {
              if (i.id != e["event"]["_def"]["publicId"]) {
                events.push(i);
              }
            });
            this.calendarOptions.events = events;
            this.$emit("getEleveInfo");

            this.toast.add({
              severity: "success",
              summary: "Disponibilité supprimée",
              detail:
                "Veuillez cliquer sur le bouton agence pour prévenir votre agence du changement",
              life: 3000,
            });
          })
          .catch((error) => {
            console.log(error);
          });
      } else if (
        e["event"]["_def"]["extendedProps"]["type"] == "resa" &&
        e["event"]["_def"]["extendedProps"]["motif"] == false &&
        e["event"]["_def"]["extendedProps"]["done"] == false
      ) {
        let monoResa = this.moniteurs.find(
          (m) => m.idMono == e["event"]["_def"]["extendedProps"]["resourceId"],
        );

if (monoResa.prenom != "Simulateur") {
          if (minutesSinceResa <= 30) {
            this.popupFreeCancel = true;
          } else {
            window.api
              .get("/type_motifs", {
                headers: {
                  Authorization: "Bearer " + this.$store.state.token,
                },
              })
              .then((response) => {
                this.typeMotif = response.data["hydra:member"];
                this.popupMotif = true;
              })
              .catch((error) => {
                console.log(error);
              });
          }
        } else {
          window.api
            .get("/eleve/" + this.$store.state.user.id + "/can-cancel-simu", {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            })
            .then((response) => {
              if (response.data.canCancel) {
                if (minutesSinceResa <= 30) {
                  this.popupFreeCancel = true;
                } else {
                  window.api
                    .get("/type_motifs", {
                      headers: {
                        Authorization: "Bearer " + this.$store.state.token,
                      },
                    })
                    .then((res) => {
                      this.typeMotif = res.data["hydra:member"];
                      this.popupMotif = true;
                    })
                    .catch((error) => {
                      console.log(error);
                    });
                }
              } else {
                this.cancelRdvSimu = true;
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      } else if (
        e["event"]["_def"]["extendedProps"]["type"] == "creneaudispo"
      ) {
        if (this.apMono && this.apMono.surnom === "Simu" && this.simuHoursRemaining <= 0) {
          this.showSimuDoneDialog = true;
          this.$emit("resetMono");
          this.calendarOptions.events = this.calendarOptions.events.filter(
            (ev) => ev.type != "creneaudispo",
          );
          this.apMono = null;
          this.monoResa = "";
          return;
        }
        this.setResaWeek();
      }
    },

    select(e) {
      this.selectEvent = e;
      this.step = 1;
      this.lieuDeb = "";
      this.LieuFin = "";
      this.monoResa == "";

      if (!this.$store.state.dispoOrResa) {
        if (this.isMobile) return;
        if (this.lieu != "") {
          this.setDispo();
        } else {
          alert("Veuillez saisir un lieu pour poser votre dispo");
        }
      } else {
        if (this.eleve.agence.dureeHeure == 1) {
          this.showResaMod = true;
          const diffMs = Math.abs(e.end - e.start); // différence en millisecondes
          const diffHeures = diffMs / (1000 * 60 * 60); // conversion en heures
          if (diffHeures != this.eleve.agence.dureeHeure) {
            alert(
              "Vous devez sélectionner un cours de " +
                this.eleve.agence.dureeHeure +
                "H pour pouvoir effectuer une réservation",
            );
          } else if (e.start.getMinutes() != 0 || e.end.getMinutes() != 0) {
            alert("Veuillez sélectionner votre cours sur des heures pleines.");
          } else {
            this.setResa();
            this.headerResa =
              "Réservation d'un cours : " +
              moment(this.selectEvent.startStr).format("ddd DD/MM/YY - HH") +
              "h à " +
              moment(this.selectEvent.endStr).format("HH") +
              "h";
          }
        } else {
          alert("Veuillez choisir un moniteur en haut à gauche de l'écran.");
        }
      }
    },

    buildCancelMailPayload(cas) {
      let event = this.selectEvent["event"];
      let title = event.title || "";
      let spaceIndex = title.indexOf(" ");
      let moniteurNom = spaceIndex !== -1 ? title.substring(0, spaceIndex) : title;
      let moniteurPrenom = spaceIndex !== -1 ? title.substring(spaceIndex + 1) : "";

      return {
        type: "rdv annnule eleve",
        email: this.eleve.email,
        cas: cas,
        start: moment(event.start).format("YYYY-MM-DDTHH:mm:ss"),
        end: moment(event.end).format("YYYY-MM-DDTHH:mm:ss"),
        lieuDebutNom: event["_def"]["extendedProps"]["lieuDeb"],
        lieuFinNom: event["_def"]["extendedProps"]["lieuFin"],
        moniteurNom: moniteurNom,
        moniteurPrenom: moniteurPrenom,
      };
    },

    setFreeCancel() {
      this.loadMotifBtn = true;
      let nowDate = new Date();
      window.api
        .post(
          "/cancel/apointment/1/" +
            this.selectEvent["event"]["_def"]["publicId"] +
            "/" +
            this.$store.state.user.id,
          {
            com: "Annulation Elève",
            now: moment(nowDate.date).format("YYYY-MM-DDTHH:mm:ss"),
          },
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          },
        )
        .then((response) => {
          this.$emit("getEleves");
          this.$emit("getEleveInfo");
          this.popupFreeCancel = false;
          this.loadMotifBtn = false;

          window.api
            .post(
              "/sendMail",
              this.buildCancelMailPayload("30min"),
              {
                headers: {
                  Authorization: "Bearer " + this.$store.state.token,
                },
              },
            )
            .then(() => {})
            .catch((error) => {
              console.log(error);
            })
            .finally(() => {
              if (response.data.apointment == "ok") {
                window.location.reload();
              } else {
                this.calendarOptions.events = this.calendarOptions.events.filter(
                  (a) => a.id != response.data.apointment.id,
                );
              }
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    setMotif() {
      this.loadMotifBtn = true;
      let nowDate = new Date();
      window.api
        .post(
          "/cancel/apointment/1/" +
            this.selectEvent["event"]["_def"]["publicId"] +
            "/" +
            this.$store.state.user.id,
          {
            com: "Annulation Elève",
            now: moment(nowDate.date).format("YYYY-MM-DDTHH:mm:ss"),
          },
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          },
        )
        .then((response) => {
          this.$emit("getEleves");
          this.$emit("getEleveInfo");
          this.motif.leTypeMotif = null;
          this.motif.com = "";
          this.popupMotif = false;
          this.loadMotifBtn = false;

          if (response.data.apointment == "ok") {
            window.api
              .post(
                "/sendMail",
                this.buildCancelMailPayload(this.hAnnulation < this.limitAnnulation ? "moins48h" : "plus48h"),
                {
                  headers: {
                    Authorization: "Bearer " + this.$store.state.token,
                  },
                },
              )
              .then(() => {})
              .catch((error) => {
                console.log(error);
              })
              .finally(() => {
                window.location.reload();
              });
          } else {
            if (response.data.apointment.indispoDelete.length != 0) {
              response.data.apointment.indispoDelete.forEach((i) => {
                let filterEvent = this.calendarOptions.events.filter(
                  (e) => i["id"] != e.id && e.type != "indispoeleve",
                );
                this.calendarOptions.events = filterEvent;
              });
            }

            if (
              response.data.apointment.typeMotif != "Incident" &&
              response.data.apointment.typeMotif != "Autre" &&
              response.data.apointment.typeMotif != "Eleve Absent"
            ) {
              let filter = [];

              this.calendarOptions.events.forEach((a) => {
                if (a.id != response.data.apointment.id) {
                  filter.push(a);
                }
              });

              this.calendarOptions.events = filter;
            } else if (response.data.apointment.typeMotif == "Incident") {
              let find = null;

              this.calendarOptions.events.forEach((a) => {
                if (a.id == response.data.apointment.id) {
                  find = a;
                }
              });

              let filter = [];

              this.calendarOptions.events.forEach((a) => {
                if (a.id != response.data.apointment.id) {
                  filter.push(a);
                }
              });

              find.title = find.title + " - " + response.data.apointment.motif;
              find.motif = response.data.apointment.motif;
              find.color = "yellow";
              ((find.textColor = "black"), filter.push(find));

              this.calendarOptions.events = filter;
            } else if (response.data.apointment.typeMotif == "Autre") {
              let filter = [];

              this.calendarOptions.events.forEach((a) => {
                if (a.id != response.data.apointment.id) {
                  filter.push(a);
                }
              });
              this.calendarOptions.events = filter;
            } else if (response.data.apointment.typeMotif == "Eleve Absent") {
              let apStart = new Date(response.data.apointment.start.date);
              if (apStart.getDay() === 1 || apStart.getDay() === 2) {
                this.limitAnnulation = 48;
              } else {
                this.limitAnnulation = 48;
              }

              let hDiff = this.diff_hours(
                new Date(response.data.apointment.start.date),
                new Date(response.data.apointment.cancelDate.date),
              );

              this.limitGoBack = this.diffMinutes(
                new Date(response.data.apointment.dateResa.date),
                new Date(response.data.apointment.cancelDate.date),
              );

              let find = null;

              this.calendarOptions.events.forEach((a) => {
                if (a.id == response.data.apointment.id) {
                  find = a;
                }
              });

              let filter = [];

              this.calendarOptions.events.forEach((a) => {
                if (a.id != response.data.apointment.id) {
                  filter.push(a);
                }
              });

              if (hDiff < this.limitAnnulation && this.limitGoBack > 30) {
                find.title =
                  find.title + " - " + response.data.apointment.motif;
                find.motif = response.data.apointment.motif;
                find.color = "red";
                filter.push(find);
                this.calendarOptions.events = filter;
              } else {
                this.calendarOptions.events = filter;
              }
            }

            window.api
              .post(
                "/sendMail",
                this.buildCancelMailPayload(this.hAnnulation < this.limitAnnulation ? "moins48h" : "plus48h"),
                {
                  headers: {
                    Authorization: "Bearer " + this.$store.state.token,
                  },
                },
              )
              .then(() => {})
              .catch((error) => {
                console.log(error);
              });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    diff_hours(dt2, dt1) {
      let diff = (dt2.getTime() - dt1.getTime()) / 1000;
      diff /= 60 * 60;
      return Math.abs(Math.round(diff));
    },

    diffMinutes(date1, date2) {
      const diffMs = Math.abs(date2 - date1);
      const diffMin = Math.floor(diffMs / (1000 * 60));

      return diffMin;
    },
  },
};
</script>

<style scoped>
div.main-content {
  width: 95%;
  margin: auto;
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
}

div.calendar-div {
  width: 100%;
}

select {
  width: 20%;
  padding: 16px 20px;
  border: none;
  border-radius: 4px;
  background-color: #f1f1f1;
}

input[type="text"]#motifText {
  margin-top: 2em;
  width: 100%;
  padding: 12px 20px;
  display: inline-block;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

div.inputMono {
  margin-top: 2em;
  font-size: 20px;
}

button.stepBtn {
  float: right;
}

div.inputMono input {
  margin-top: 2em;
}

div.stepper {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2em;
  font-size: 25px;
}

div.stepper div.firstStep {
  border: 1px solid black;
  border-radius: 3%;
  padding: 0.3%;
}

div.stepper div.link {
  padding: 0.3%;
}

div.stepper div.secondStep {
  border: 1px solid black;
  border-radius: 3%;
  padding: 0.3%;
}

div.stepper div.thirdStep {
  border: 1px solid black;
  border-radius: 3%;
  padding: 0.3%;
}

div.stepper div.active {
  background-color: #0d6efd;
  border: 1px solid #0d6efd;
  color: white;
}

div.stepper div.inactive {
  opacity: 0.3;
}

/* Fond jaune pour le jour actuel */
:deep(.fc-day-today) {
  background-color: #fffde7 !important;
}

/* En-têtes des colonnes de jours */
:deep(.fc-col-header-cell) {
  padding: 8px 0;
  font-size: 13px;
}

:deep(.fc-col-header-cell-cushion) {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  text-decoration: none;
  color: #555;
  font-weight: 500;
  text-transform: capitalize;
}

/* Jour actuel : numéro en badge bleu */
:deep(.fc-day-today .fc-col-header-cell-cushion) {
  color: #1a73e8;
}

/* Style des événements */
:deep(.fc-event) {
  border-radius: 6px !important;
  border: none !important;
  border-left: 3px solid rgba(0, 0, 0, 0.15) !important;
  font-size: 11px !important;
  padding: 3px 6px !important;
  box-shadow: none !important;
  transition:
    transform 0.1s,
    box-shadow 0.1s !important;
  overflow: hidden !important;
  cursor: pointer !important;
}

:deep(.fc-event:hover) {
  transform: translateY(-1px) !important;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.12) !important;
}

:deep(.fc-event-time) {
  font-size: 10px;
  display: block;
}

:deep(.ev-time) {
  font-size: 10px;
  font-weight: 700;
  opacity: 0.75;
  display: block;
  margin-bottom: 1px;
  letter-spacing: 0.02em;
}

:deep(.ev-title) {
  font-weight: 600;
  font-size: 12px;
  display: block;
  margin-bottom: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

:deep(.ev-meta) {
  font-size: 10.5px;
  opacity: 0.85;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.35;
}

:deep(.ev-badge) {
  display: inline-block;
  margin-top: 10px;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.04em;
  padding: 1px 5px;
  border-radius: 20px;
  text-align: center;
  background: rgba(255, 255, 255, 0.3);
}

:deep(.fc-event-main) {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* Grille générale */
:deep(.fc-timegrid-slot) {
  height: 40px;
}

:deep(.fc-timegrid-slot-label) {
  font-size: 12px;
  color: #888;
}

/* Suppression de la bordure trop marquée */
:deep(.fc-scrollgrid) {
  border-color: #e0e0e0 !important;
}

:deep(.fc-scrollgrid td),
:deep(.fc-scrollgrid th) {
  border-color: #e0e0e0 !important;
}

/* Toolbar générale */
:deep(.fc-toolbar) {
  padding: 8px 12px;
}

/* Suppression du style par défaut des groupes de boutons */
:deep(.fc-button-group),
:deep(.fc-button) {
  box-shadow: none !important;
  outline: none !important;
}

/* Boutons navigation (< >) */
:deep(.fc-prev-button),
:deep(.fc-next-button) {
  background-color: transparent !important;
  border: 1px solid #e0e0e0 !important;
  border-radius: 50% !important;
  color: #555 !important;
  width: 28px !important;
  height: 28px !important;
  padding: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}

:deep(.fc-prev-button:hover),
:deep(.fc-next-button:hover) {
  background-color: #f1f3f4 !important;
}

/* Bouton Aujourd'hui */
:deep(.fc-today-button) {
  background-color: transparent !important;
  border: 1px solid #e0e0e0 !important;
  border-radius: 20px !important;
  color: #555 !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  padding: 4px 14px !important;
  text-transform: capitalize !important;
}

:deep(.fc-today-button:hover) {
  background-color: #f1f3f4 !important;
}

:deep(.fc-today-button:disabled) {
  opacity: 0.5 !important;
}

/* Boutons Semaine / Jour / Dimanche */
:deep(.fc-timeGridWeek-button),
:deep(.fc-timeGridDay-button),
:deep(.fc-hideSunday-button) {
  background-color: transparent !important;
  border: none !important;
  border-radius: 20px !important;
  color: #555 !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  padding: 4px 14px !important;
}

:deep(.fc-timeGridWeek-button:hover),
:deep(.fc-timeGridDay-button:hover),
:deep(.fc-hideSunday-button:hover) {
  background-color: #f1f3f4 !important;
}

/* Bouton actif */
:deep(.fc-timeGridWeek-button.fc-button-active),
:deep(.fc-timeGridDay-button.fc-button-active),
:deep(.fc-hideSunday-button.fc-button-active) {
  background-color: #e8f0fe !important;
  border-color: #e8f0fe !important;
  color: #1a73e8 !important;
}

/* Container groupe de boutons droits */
:deep(.fc-toolbar-chunk:last-child) {
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 24px;
  padding: 2px 4px;
}

/* ===== Dialogs annulation ===== */
.cancel-dialog {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 4px 0 8px;
}

.cancel-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 700;
  padding: 6px 14px;
  border-radius: 20px;
  width: fit-content;
}

.cancel-badge--warning {
  background: #fff7ed;
  color: #c2410c;
  border: 1px solid #fed7aa;
}
.cancel-badge--info {
  background: #eff6ff;
  color: #1d4ed8;
  border: 1px solid #bfdbfe;
}
.cancel-badge--free {
  background: #f0fdf4;
  color: #15803d;
  border: 1px solid #bbf7d0;
}
.cancel-badge--blocked {
  background: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecaca;
}

.cancel-message {
  font-size: 15px;
  color: #374151;
  line-height: 1.6;
  margin: 0;
}

.cancel-contact {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 12px 16px;
}

.cancel-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 4px;
}

.cancel-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 20px;
  border-radius: 8px;
  border: none;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  font-family: inherit;
}
.cancel-btn:disabled { opacity: 0.6; cursor: not-allowed; }

.cancel-btn--ghost {
  background: transparent;
  border: 1px solid #e2e8f0;
  color: #64748b;
}
.cancel-btn--ghost:hover { background: #f8fafc; }

.cancel-btn--danger {
  background: #ef4444;
  color: #fff;
}
.cancel-btn--danger:hover:not(:disabled) { background: #dc2626; }

.cancel-btn--success {
  background: #22c55e;
  color: #fff;
}
.cancel-btn--success:hover:not(:disabled) { background: #16a34a; }

.cancel-btn--info {
  background: #3b82f6;
  color: #fff;
}
.cancel-btn--info:hover:not(:disabled) { background: #2563eb; }

@media (max-width: 1400px) {
  .calendar-div {
    padding-bottom: 66px;
  }
}
</style>
